import './assets/styles/main.css';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import { csvConverter } from '@components/CsvConverter.js';

Alpine.plugin(collapse);
Alpine.data('csvConverter', csvConverter);
window.Alpine = Alpine;
Alpine.start();
